// src/data/downpipeProducts.js
import { EXHAUST_PRODUCTS } from "./exhaustProducts.js";

const toDpSlug = (slug) => slug.replace(/^ul-(catback|valved)-/i, "ul-dp-");
const swapToDownpipeImg = (u) => (u ? u.replace("/assets/p-exh-", "/assets/p-dp-") : u);

// 👇 Per-car prices: base = Race Catless, catted = High-Flow Catted
const DP_PRICES = {
  "ul-dp-f90":  { base: 1075, catted: 1950 },
  "ul-dp-g90":  { base: 1800, catted: 2550 },
  "ul-dp-g82":  { base: 770, catted: 999 },
  "ul-dp-c63":  { base: 800, catted: 1100 },
  "ul-dp-g63":  { base: 1099, catted: 1299 },
  "ul-dp-rs6":  { base: 900, catted: 1150 },
  "ul-dp-rs5":  { base: 900, catted: 1150 },
  "ul-dp-e63":  { base: 950, catted: 1150 },
  "ul-dp-r8":   { base: 4999, catted: 5900 },
  "ul-dp-huracan": { base: 4999, catted: 5900 },
  "ul-dp-r35":  { base: 975, catted: 1275 },
  "ul-dp-911":  { base: 1450, catted: 2350 },
  "ul-dp-720s": { base: 1575, catted: 2498 },
  "ul-dp-570s": { base: 1475, catted: 2475 },
  "ul-dp-488":  { base: 1799, catted: 2475 },
  "ul-dp-aventadorsvj": { base: 3375, catted: 6675 },
  "ul-dp-urus": { base: 1975, catted: 2775 },
  "ul-dp-gt4":  { base: 1475, catted: 2575 },
  "ul-dp-gt3":  { base: 1945, catted: 3845 },
  "ul-dp-turbos": { base: 1545, catted: 2445 },
  "ul-dp-m2":   { base: 550, catted: 850 },
  "ul-dp-M8":   { base: 1075, catted: 1950 },
  "ul-dp-M6":   { base: 845, catted: 1275 },
  "ul-dp-F10":  { base: 845, catted: 1275 },
  "ul-dp-F80":  { base: 770, catted: 999 },
  "ul-dp-F87":  { base: 770, catted: 999 },
  "ul-dp-M340": { base: 700, catted: 900 },
  "ul-dp-g80":  { base: 770, catted: 999 },
  "ul-dp-aventadors": { base: 3375, catted: 6675 },
  "ul-dp-750s": { base: 1575, catted: 2498 },
  "ul-dp-765LT":{ base: 1575, catted: 2498 },
  "ul-dp-supra":{ base: 700, catted: 900 },
  "ul-dp-amggts": { base: 1775, catted: 2275 },
  "ul-dp-amggt":  { base: 1375, catted: 2075 },
  "ul-dp-rev":    { base: 4875, catted: 7975 },
  "ul-dp-c8":     { base: 960, catted: 1240 },
};

const DEFAULTS = { base: 1995, catted: 2295 };

export const DOWNPIPE_PRODUCTS = EXHAUST_PRODUCTS.map((p) => {
  const slug = toDpSlug(p.slug);
  const price = DP_PRICES[slug] ?? DEFAULTS;
  const upcharge = Math.max(0, (price.catted ?? DEFAULTS.catted) - (price.base ?? DEFAULTS.base));

  return {
    ...p,
    id: `dp_${p.id}`,
    slug,
    name: p.name,
    img: swapToDownpipeImg(p.img),
    basePrice: price.base,          // shown when "Race Catless" is selected
    cattedUpcharge: upcharge,       // extra if "High-Flow Catted" is chosen
    cattedPrice: price.catted,      // (optional) available if you ever want to show it directly
  };
});
